import { AspectRatio, Avatar, Box, Group, Image, NumberFormatter, Stack, Text } from '@mantine/core';
type WinUserProps = {
  url: string;
  username: string;
  price: number;
};
export const WinUser: React.FC<WinUserProps> = ({
  url,
  username,
  price
}) => {
  return <Stack gap={4}>
      <AspectRatio ratio={60 / 60}>
        <Image src={url} alt="user" radius={5} />
      </AspectRatio>
      <Group align="center" wrap="nowrap" gap={4}>
        <Avatar src="/assets/ava3.png" size={14} />
        <Box w="60%">
          <Text truncate="end" fz={13} fw={500} c="var(--text-dark)">
            {username}
          </Text>
        </Box>
      </Group>
      <Text fz="xs" fw={700} c="var(--mantine-color-prime-8)">
        <NumberFormatter prefix="$" thousandSeparator="." decimalSeparator="," value={price} />
      </Text>
    </Stack>;
};